import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceListComponent } from './service-list.component';
import { CoreModule, FormControlModule } from '@linkdev/shared-library';
import { FormControl, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@linkdev/portals-shared';
import { DocumentsModule } from '@linkdev/document-manage-library';
import { AccessManagementModule } from '@linkdev/access-manage-library';
import { TranslateModule } from '@ngx-translate/core';
import { SafePipe } from './safe.pipe';

@NgModule({
  declarations: [ ServiceListComponent , SafePipe],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    DocumentsModule,
    AccessManagementModule,
    TranslateModule,
    CoreModule,
    FormControlModule,
    RouterModule
    
    
  ],
  exports: [ServiceListComponent],
})
export class ServiceListModule { }
